import { NAV_ITEMS } from '../lib/constants'

export default function Sidebar({ activeTab, setActiveTab, currentUser, onLogout, onLogin, unreadInvites, unreadChats = 0, unreadNotifications = 0, streakCount = 0, onFeedback, onCreatePost }) {
  return (
    <aside className="flex flex-col h-full bg-white/80 backdrop-blur-md border-r border-gray-200 w-64 shrink-0 py-6 px-3 overflow-y-auto">
      <div className="px-3 mb-8 flex items-start justify-between gap-3">
        <div>
          <p className="title-font text-xs font-bold uppercase tracking-[0.2em] text-orange-600">Co-Eater</p>
          <h1 className="title-font text-xl font-bold text-gray-900 mt-1">Platform</h1>
        </div>
        {currentUser && (
          <button
            onClick={onCreatePost}
            className="rounded-full bg-gradient-to-r from-red-500 to-orange-500 px-3 py-2 text-xs font-semibold text-white shadow-sm hover:from-red-600 hover:to-orange-600 transition"
          >
            + Post
          </button>
        )}
      </div>
      <nav className="flex-1 space-y-1">
        {NAV_ITEMS.map(item => (
          <button key={item.id} onClick={() => setActiveTab(item.id)}
            className={`w-full flex items-center gap-3 rounded-2xl px-4 py-3 text-sm font-semibold transition
              ${activeTab === item.id ? 'bg-orange-500 text-white shadow-md' : 'text-gray-700 hover:bg-orange-50 hover:text-orange-700'}`}>
            <span className="text-base">{item.icon}</span>
            <span>{item.label}</span>
            {item.id === 'invites' && unreadInvites > 0 && (
              <span className="ml-auto rounded-full bg-red-500 text-white text-xs px-2 py-0.5">{unreadInvites}</span>
            )}
            {item.id === 'chats' && unreadChats > 0 && (
              <span className="ml-auto rounded-full bg-red-500 text-white text-xs px-2 py-0.5">{unreadChats}</span>
            )}
            {item.id === 'notification' && unreadNotifications > 0 && (
              <span className="ml-auto rounded-full bg-red-500 text-white text-xs px-2 py-0.5">{unreadNotifications > 99 ? '99+' : unreadNotifications}</span>
            )}
            {item.id === 'streak' && (
              <span className="ml-auto rounded-full bg-gray-900 text-white text-xs px-2 py-0.5">{streakCount}</span>
            )}
          </button>
        ))}
        <button
          onClick={onFeedback}
          className="w-full flex items-center gap-3 rounded-2xl px-4 py-3 text-sm font-semibold text-gray-700 hover:bg-orange-50 hover:text-orange-700 transition"
        >
          <span className="text-base">💬</span>
          <span>Give Feedback</span>
        </button>
      </nav>
      <div className="border-t border-gray-200 pt-4 mt-4">
        {currentUser ? (
          <div className="space-y-2">
            <div className="flex items-center gap-3 px-3 py-2 rounded-2xl bg-orange-50">
              <img src={currentUser.profilePicture || `https://api.dicebear.com/7.x/thumbs/svg?seed=${encodeURIComponent(currentUser.name)}`}
                className="h-10 w-10 rounded-xl object-cover bg-orange-200 shrink-0" alt={currentUser.name} />
              <div className="min-w-0">
                <p className="text-sm font-bold text-gray-900 truncate">{currentUser.name}</p>
                <p className="text-xs text-gray-500 truncate">{currentUser.location?.area || currentUser.email}</p>
              </div>
            </div>
            <button onClick={onLogout} className="w-full flex items-center gap-3 rounded-2xl px-4 py-3 text-sm font-semibold text-red-600 hover:bg-red-50 transition">
              🚪 Logout
            </button>
          </div>
        ) : (
          <button onClick={onLogin} className="w-full rounded-2xl bg-gradient-to-r from-red-500 to-orange-500 px-4 py-3 text-sm font-semibold text-white hover:from-red-600 hover:to-orange-600 transition">
            🍽️ Login / Sign Up
          </button>
        )}
      </div>
    </aside>
  )
}
